import { gql } from '@apollo/client';


export const GET_PERSON_RELATIONSHIPS_LENGTH = gql`
  query GET_PERSON_RELATIONSHIPS_LENGTH($personId: ID!, $originatorId: ID!){
    getPerson(personId: $personId, originatorId: $originatorId) {
      id
      relationships {
        id
        person {
          id
        }
      }
    }
  }
`;


